import _slicedToArray from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { cloneElement, toChildArray } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
import classNames from 'classnames';
var transitionName = 'uppy-transition-slideDownUp';
var duration = 250;
/**
 * Vertical slide transition.
 *
 * This can take a _single_ child component, which _must_ accept a `className` prop.
 *
 * Currently this is specific to the `uppy-transition-slideDownUp` transition,
 * but it should be simple to extend this for any type of single-element
 * transition by setting the CSS name and duration as props.
 */

function Slide(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      cachedChildren = _useState2[0],
      setCachedChildren = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      className = _useState4[0],
      setClassName = _useState4[1];

  var enterTimeoutRef = useRef();
  var leaveTimeoutRef = useRef();
  var animationFrameRef = useRef();

  var handleEnterTransition = function handleEnterTransition() {
    setClassName("".concat(transitionName, "-enter"));
    cancelAnimationFrame(animationFrameRef.current);
    clearTimeout(leaveTimeoutRef.current);
    leaveTimeoutRef.current = undefined;
    animationFrameRef.current = requestAnimationFrame(function () {
      setClassName("".concat(transitionName, "-enter ").concat(transitionName, "-enter-active"));
      enterTimeoutRef.current = setTimeout(function () {
        setClassName('');
      }, duration);
    });
  };

  var handleLeaveTransition = function handleLeaveTransition() {
    setClassName("".concat(transitionName, "-leave"));
    cancelAnimationFrame(animationFrameRef.current);
    clearTimeout(enterTimeoutRef.current);
    enterTimeoutRef.current = undefined;
    animationFrameRef.current = requestAnimationFrame(function () {
      setClassName("".concat(transitionName, "-leave ").concat(transitionName, "-leave-active"));
      leaveTimeoutRef.current = setTimeout(function () {
        setCachedChildren(null);
        setClassName('');
      }, duration);
    });
  };

  useEffect(function () {
    var child = toChildArray(children)[0];
    if (cachedChildren === child) return;

    if (child && !cachedChildren) {
      handleEnterTransition();
    } else if (cachedChildren && !child && !leaveTimeoutRef.current) {
      handleLeaveTransition();
    }

    setCachedChildren(child);
  }, [children, cachedChildren]); // Dependency array to trigger effect on children change

  useEffect(function () {
    return function () {
      clearTimeout(enterTimeoutRef.current);
      clearTimeout(leaveTimeoutRef.current);
      cancelAnimationFrame(animationFrameRef.current);
    };
  }, []); // Cleanup useEffect

  if (!cachedChildren) return null;
  return cloneElement(cachedChildren, {
    className: classNames(className, cachedChildren.props.className)
  });
}

export default Slide;